import {registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localePt from '@angular/common/locales/pt';
import {Component, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

registerLocaleData(localePt, 'pt');
registerLocaleData(localeEn, 'en');

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit
{
    private readonly translate = inject(TranslateService);

    public ngOnInit(): void
    {
        this.translate.addLangs(['pt', 'en']);
        const language: string = window.localStorage.getItem('language');

        if (language && language !== '')
        {
            this.translate.setDefaultLang(language);
            this.translate.use(language);
        }
        else
        {
            this.translate.setDefaultLang('pt');
            this.translate.use('pt');
        }
    }
}
